import {
  IProductModel,
  IDiaryModel,
  IEnvironmentModel,
  IAuthenticationModel
} from 'src/types/product';

// ----------------------------------------------------------------------
// Mock Products theo mocl-data specification

export const _mockProducts: IProductModel[] = [
  {
    id: 'SNL001',
    name: 'Sâm Ngọc Linh Cao Cấp',
    id_diary: 'DRY001',
    id_environment: 'ENV001',
    id_authentication: 'AUTH001',
    blogchain: '0x1a2b3c4d5e6f7g8h9i0j1k2l3m4n5o6p',
    description: 'Sâm Ngọc Linh cao cấp được trồng tại độ cao 1500-2000m trên núi Ngọc Linh, chăm sóc đặc biệt với công nghệ hiện đại. Sản phẩm này nổi bật với hàm lượng saponin cao (≥4.5%), củ to, hình dáng đẹp, thích hợp làm quà tặng cao cấp hoặc sử dụng cho sức khỏe lâu dài.\n\nCông dụng chính: Tăng cường hệ miễn dịch, cải thiện chức năng tim mạch, hỗ trợ giảm stress và mệt mỏi, tăng cường trí nhớ và khả năng tập trung, chống lão hóa tự nhiên.\n\nCách sử dụng: Dùng 2-3 lát sâm khô mỗi ngày, ngâm trà hoặc hầm với thức ăn. Nên sử dụng buổi sáng sau ăn để đạt hiệu quả tốt nhất.\n\nBảo quản: Nơi khô ráo, thoáng mát, tránh ánh nắng trực tiếp. Độ ẩm ≤12%.'
  },
  {
    id: 'SNL002',
    name: 'Sâm Ngọc Linh Tự Nhiên',
    id_diary: 'DRY002',
    id_environment: 'ENV002',
    id_authentication: 'AUTH002',
    blogchain: '0x2b3c4d5e6f7g8h9i0j1k2l3m4n5o6p7q',
    description: 'Sâm Ngọc Linh tự nhiên được thu hoạch từ những cây sâm già 15-20 năm tuổi, phát triển hoàn toàn tự nhiên trong môi trường rừng nguyên sinh. Đây là loại sâm có giá trị dinh dưỡng và dược tính cao nhất.\n\nCông dụng chính: Bồi bổ sức khỏe toàn diện, tăng cường sinh lực, cải thiện chức năng gan thận, hỗ trợ điều trị bệnh tiểu đường, tăng cường khả năng sinh sản.\n\nCách sử dụng: Dùng 1-2 lát mỗi ngày, có thể ngâm rượu hoặc sắc nước uống. Nên sử dụng liên tục trong 3-6 tháng để đạt hiệu quả tốt nhất.\n\nBảo quản: Bảo quản trong hộp kín, nơi khô ráo, nhiệt độ thường. Tránh tiếp xúc với ánh sáng trực tiếp.'
  },
  {
    id: 'SNL003',
    name: 'Sâm Ngọc Linh Hữu Cơ',
    id_diary: 'DRY003',
    id_environment: 'ENV003',
    id_authentication: 'AUTH003',
    blogchain: '0x3c4d5e6f7g8h9i0j1k2l3m4n5o6p7q8r',
    description: 'Sâm Ngọc Linh hữu cơ được trồng theo tiêu chuẩn hữu cơ quốc tế, không sử dụng hóa chất, thuốc trừ sâu hay phân bón hóa học. Sản phẩm đã được chứng nhận hữu cơ bởi các tổ chức uy tín.\n\nCông dụng chính: An toàn tuyệt đối cho sức khỏe, phù hợp với trẻ em và phụ nữ mang thai, tăng cường miễn dịch tự nhiên, cải thiện giấc ngủ, giảm căng thẳng.\n\nCách sử dụng: Có thể sử dụng hàng ngày với liều lượng 2-3g, phù hợp để pha trà hoặc nấu cháo. Đặc biệt tốt cho người có cơ địa nhạy cảm.\n\nBảo quản: Bảo quản trong túi hút chân không, nơi khô ráo, thoáng mát. Sau khi mở túi nên sử dụng trong vòng 6 tháng.'
  },
  {
    id: 'SNL004',
    name: 'Sâm Ngọc Linh Khô Lát',
    id_diary: 'DRY004',
    id_environment: 'ENV004',
    id_authentication: 'AUTH004',
    blogchain: '0x4d5e6f7g8h9i0j1k2l3m4n5o6p7q8r9s',
    description: 'Sâm Ngọc Linh khô lát được chế biến từ những củ sâm tươi chất lượng cao, sấy khô bằng công nghệ hiện đại để giữ nguyên dưỡng chất. Sản phẩm tiện lợi, dễ sử dụng và bảo quản lâu dài.\n\nCông dụng chính: Bồi bổ khí huyết, tăng cường thể lực, cải thiện trí nhớ và khả năng tập trung, hỗ trợ người già và người bệnh hồi phục sức khỏe.\n\nCách sử dụng: Dùng 3-5 lát mỗi lần, ngâm nước sôi hoặc pha trà uống. Có thể kết hợp với mật ong hoặc chanh để tăng hương vị.\n\nBảo quản: Bảo quản trong hộp kín, nơi khô ráo. Độ ẩm môi trường ≤15%. Tránh ánh nắng trực tiếp và nơi ẩm ướt.'
  },
  {
    id: 'SNL005',
    name: 'Sâm Ngọc Linh Tươi',
    id_diary: 'DRY005',
    id_environment: 'ENV005',
    id_authentication: 'AUTH005',
    blogchain: '0x5e6f7g8h9i0j1k2l3m4n5o6p7q8r9s0t',
    description: 'Sâm Ngọc Linh tươi được thu hoạch và vận chuyển ngay trong ngày, giữ nguyên độ tươi ngon và hàm lượng dưỡng chất cao nhất. Đây là dạng sâm có giá trị dinh dưỡng và hương vị tự nhiên nhất.\n\nCông dụng chính: Cung cấp năng lượng tức thì, tăng cường sinh lực mạnh mẽ, cải thiện tuần hoàn máu, hỗ trợ tiêu hóa và tăng cường chức năng gan.\n\nCách sử dụng: Có thể ăn trực tiếp, nấu canh, hầm với gà hoặc ép nước uống. Nên sử dụng trong vòng 7 ngày sau khi nhận hàng.\n\nBảo quản: Bảo quản trong ngăn mát tủ lạnh ở nhiệt độ 2-8°C. Tránh để ở nhiệt độ thường quá lâu.'
  },
  {
    id: 'SNL006',
    name: 'Sâm Ngọc Linh Ngâm Rượu',
    id_diary: 'DRY006',
    id_environment: 'ENV006',
    id_authentication: 'AUTH006',
    blogchain: '0x6f7g8h9i0j1k2l3m4n5o6p7q8r9s0t1u',
    description: 'Sâm Ngọc Linh ngâm rượu được chế biến từ sâm tự nhiên cao cấp ngâm trong rượu trắng 45 độ trong thời gian tối thiểu 12 tháng. Sản phẩm có màu vàng đẹp mắt và hương thơm đặc trưng.\n\nCông dụng chính: Tăng cường sinh lực nam giới, cải thiện chức năng sinh lý, hỗ trợ điều trị đau nhức xương khớp, tăng cường tuần hoàn máu.\n\nCách sử dụng: Uống 10-20ml mỗi lần, 2 lần/ngày sau bữa ăn. Không nên uống quá liều quy định. Không dành cho trẻ em và phụ nữ mang thai.\n\nBảo quản: Bảo quản ở nơi khô ráo, thoáng mát, tránh ánh nắng trực tiếp. Có thể bảo quản lâu dài mà không bị hỏng.'
  }
];

// Mock Diary theo mocl-data specification
export const _mockDiary: IDiaryModel[] = [
  {
    id: 'DRY001',
    date: new Date('2024-01-20'),
    overview_image: '/assets/images/about/team_2.jpg',
    detail_image: '/assets/images/about/team_1.jpg',
    number_leaves: 8,
    status: 0, // Living
    health_points: 5, // VeryHealthy
    idUser: 'USER001'
  },
  {
    id: 'DRY002',
    date: new Date('2024-01-19'),
    overview_image: '/assets/images/about/team_3.jpg',
    detail_image: '/assets/images/about/team_4.jpg',
    number_leaves: 12,
    status: 0, // Living
    health_points: 4, // PrettyGood
    idUser: 'USER002'
  },
  {
    id: 'DRY003',
    date: new Date('2024-01-18'),
    overview_image: '/assets/images/about/team_5.jpg',
    detail_image: '/assets/images/about/hero.jpg',
    number_leaves: 6,
    status: 2, // Hibernation
    health_points: 3, // Medium
    idUser: 'USER003'
  },
  {
    id: 'DRY004',
    date: new Date('2024-01-17'),
    overview_image: '/assets/images/home/hero/light_1.webp',
    detail_image: '/assets/images/home/hero/light_2.webp',
    number_leaves: 10,
    status: 0, // Living
    health_points: 5, // VeryHealthy
    idUser: 'USER001'
  },
  {
    id: 'DRY005',
    date: new Date('2024-01-16'),
    overview_image: '/assets/images/home/presets/screen_default.webp',
    detail_image: '/assets/images/home/for_designer.webp',
    number_leaves: 7,
    status: 0, // Living
    health_points: 4, // PrettyGood
    idUser: 'USER002'
  },
  {
    id: 'DRY006',
    date: new Date('2024-01-15'),
    overview_image: '/assets/images/home/rocket.webp',
    detail_image: '/assets/images/contact/hero.jpg',
    number_leaves: 9,
    status: 0, // Living
    health_points: 5, // VeryHealthy
    idUser: 'USER003'
  }
];

// Mock Environment theo mocl-data specification
export const _mockEnvironment: IEnvironmentModel[] = [
  {
    id: 'ENV001',
    date: new Date('2024-01-20'),
    soid_moisture: 65.5,
    temperature: 18.2,
    air_humidity: 78.0,
    Rainfall: 12.5,
    note: 'Điều kiện môi trường lý tưởng cho sự phát triển của sâm'
  },
  {
    id: 'ENV002',
    date: new Date('2024-01-19'),
    soid_moisture: 62.3,
    temperature: 17.8,
    air_humidity: 75.5,
    Rainfall: 8.2,
    note: 'Độ ẩm đất hơi thấp, cần tưới nước bổ sung'
  },
  {
    id: 'ENV003',
    date: new Date('2024-01-18'),
    soid_moisture: 70.1,
    temperature: 19.5,
    air_humidity: 82.0,
    Rainfall: 15.8,
    note: 'Mưa nhiều, cần chú ý thoát nước tránh úng'
  },
  {
    id: 'ENV004',
    date: new Date('2024-01-17'),
    soid_moisture: 68.7,
    temperature: 18.9,
    air_humidity: 79.3,
    Rainfall: 10.0,
    note: 'Thời tiết thuận lợi, sâm phát triển tốt'
  },
  {
    id: 'ENV005',
    date: new Date('2024-01-16'),
    soid_moisture: 64.2,
    temperature: 17.5,
    air_humidity: 76.8,
    Rainfall: 6.5,
    note: 'Nhiệt độ hơi thấp, cần theo dõi sát sao'
  },
  {
    id: 'ENV006',
    date: new Date('2024-01-15'),
    soid_moisture: 66.8,
    temperature: 19.2,
    air_humidity: 80.5,
    Rainfall: 11.3,
    note: 'Điều kiện ổn định, phù hợp cho giai đoạn phát triển'
  }
];

// Mock Authentication theo mocl-data specification
export const _mockAuthentication: IAuthenticationModel[] = [
  {
    id: 'AUTH001',
    date: new Date('2024-01-10'),
    inspection_results: 'Đạt tiêu chuẩn xuất khẩu - Hàm lượng saponin: 4.8%, không có tạp chất độc hại, chất lượng cao cấp',
    note: 'Sản phẩm đạt chứng nhận GAP và có thể xuất khẩu'
  },
  {
    id: 'AUTH002',
    date: new Date('2024-01-09'),
    inspection_results: 'Đạt tiêu chuẩn hữu cơ - Không phát hiện dư lượng thuốc bảo vệ thực vật, hàm lượng saponin: 4.2%',
    note: 'Được cấp chứng nhận hữu cơ quốc tế'
  },
  {
    id: 'AUTH003',
    date: new Date('2024-01-08'),
    inspection_results: 'Đạt tiêu chuẩn TCVN - Hàm lượng saponin: 3.9%, độ ẩm: 11.5%, không có vi sinh vật có hại',
    note: 'Phù hợp cho thị trường nội địa'
  },
  {
    id: 'AUTH004',
    date: new Date('2024-01-07'),
    inspection_results: 'Đạt tiêu chuẩn cao cấp - Hàm lượng saponin: 5.1%, chất lượng vượt trội, phù hợp làm quà tặng',
    note: 'Sản phẩm cao cấp nhất trong lô hàng'
  },
  {
    id: 'AUTH005',
    date: new Date('2024-01-06'),
    inspection_results: 'Đạt tiêu chuẩn tươi - Độ tươi: 95%, hàm lượng nước: 75%, không có dấu hiệu hư hỏng',
    note: 'Phù hợp để chế biến ngay hoặc bảo quản ngắn hạn'
  },
  {
    id: 'AUTH006',
    date: new Date('2024-01-05'),
    inspection_results: 'Đạt tiêu chuẩn ngâm rượu - Hàm lượng saponin: 4.5%, độ cồn: 45%, màu sắc và hương vị chuẩn',
    note: 'Sản phẩm ngâm rượu đạt chất lượng xuất sắc'
  }
];


// Old 
// Legacy constants for compatibility
export const PRODUCT_GENDER_OPTIONS = [
  { label: 'Men', value: 'Men' },
  { label: 'Women', value: 'Women' },
  { label: 'Kids', value: 'Kids' },
];

export const PRODUCT_CATEGORY_OPTIONS = ['Shose', 'Apparel', 'Accessories'];

export const PRODUCT_RATING_OPTIONS = ['up4Star', 'up3Star', 'up2Star', 'up1Star'];

export const PRODUCT_COLOR_OPTIONS = [
  '#00AB55',
  '#000000',
  '#FFFFFF',
  '#FFC0CB',
  '#FF4842',
  '#1890FF',
  '#94D82D',
  '#FFC107',
];

export const PRODUCT_COLOR_NAME_OPTIONS = [
  { value: 'red', label: 'Red' },
  { value: 'blue', label: 'Blue' },
  { value: 'cyan', label: 'Cyan' },
  { value: 'green', label: 'Green' },
  { value: 'yellow', label: 'Yellow' },
  { value: 'violet', label: 'Violet' },
  { value: 'black', label: 'Black' },
  { value: 'white', label: 'White' },
];

export const PRODUCT_SIZE_OPTIONS = [
  { value: '7', label: '7' },
  { value: '8', label: '8' },
  { value: '8.5', label: '8.5' },
  { value: '9', label: '9' },
  { value: '9.5', label: '9.5' },
  { value: '10', label: '10' },
  { value: '10.5', label: '10.5' },
  { value: '11', label: '11' },
  { value: '11.5', label: '11.5' },
  { value: '12', label: '12' },
  { value: '13', label: '13' },
];

export const PRODUCT_STOCK_OPTIONS = [
  { value: 'in stock', label: 'In stock' },
  { value: 'low stock', label: 'Low stock' },
  { value: 'out of stock', label: 'Out of stock' },
];

export const PRODUCT_PUBLISH_OPTIONS = [
  {
    value: 'published',
    label: 'Published',
  },
  {
    value: 'draft',
    label: 'Draft',
  },
];

export const PRODUCT_SORT_OPTIONS = [
  { value: 'featured', label: 'Featured' },
  { value: 'newest', label: 'Newest' },
  { value: 'priceDesc', label: 'Price: High - Low' },
  { value: 'priceAsc', label: 'Price: Low - High' },
];

export const PRODUCT_CATEGORY_GROUP_OPTIONS = [
  { group: 'Clothing', classify: ['Shirts', 'T-shirts', 'Jeans', 'Leather', 'Accessories'] },
  { group: 'Tailored', classify: ['Suits', 'Blazers', 'Trousers', 'Waistcoats', 'Apparel'] },
  { group: 'Accessories', classify: ['Shoes', 'Backpacks and bags', 'Bracelets', 'Face masks'] },
];

export const PRODUCT_CHECKOUT_STEPS = ['Cart', 'Billing & address', 'Payment'];